import { PerRoadLayerType } from '@/modules/perRoad/interfaces/perRoad';

export const poissonRatios: {[index: string]: {min: number, mean: number, max: number}} = {
  [PerRoadLayerType.AC]: {
    min: 0.15,
    mean: 0.35,
    max: 0.4,
  },
  [PerRoadLayerType.CRACKED_AC]: {
    min: 0.15,
    mean: 0.35,
    max: 0.4,
  },
  [PerRoadLayerType.PCC]: {
    min: 0.14,
    mean: 0.18,
    max: 0.25,
  },
  [PerRoadLayerType.RUBBLIZED_PCC]: {
    min: 0.14,
    mean: 0.2,
    max: 0.25,
  },
  [PerRoadLayerType.CS_PCC]: {
    min: 0.14,
    mean: 0.2,
    max: 0.25,
  },
  [PerRoadLayerType.BS_PCC]: {
    min: 0.14,
    mean: 0.2,
    max: 0.25,
  },
  [PerRoadLayerType.GRANULAR_BASE]: {
    min: 0.35,
    mean: 0.4,
    max: 0.45,
  },
  [PerRoadLayerType.SOIL]: {
    min: 0.2,
    mean: 0.45,
    max: 0.5,
  },
  [PerRoadLayerType.ROCK]: {
    min: 0.1,
    mean: 0.15,
    max: 0.25,
  },
};
